@if (!isDynamicdashboard) {
  <h2><a  [ecommerceRouterLink]="['/:lang/bulletins']"><mibp-resource-string key="Dashboard_LatestBulletins"></mibp-resource-string></a></h2>
}

<mibp-circle-list [items]="bulletins" [isLoading]="isLoading" [hasError]="hasError" (retry)="load()">
  <ng-template let-item>
    <a  (click)="getBulletinDetails(item.data.bulletinId,item.data.canEdit)" class="title">{{ item.data.title }}</a>
  </ng-template>
</mibp-circle-list>
